import React from 'react';
import TableC from '../../../basicElement/TableC';

function Fte({ data }) {
    const getColumns = () => {
        const columns = [{
            title: '时间',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            width: 60
        }];

        (data || []).forEach(i => {
            const date = `${i.year}.${i.month}`;
            columns.push({
                title: date,
                dataIndex: date,
                key: date,
                width: 60
            });
        });

        return columns;
    }

    const getDataSource = () => {
        const params = { name: 'FTE' };

        data.forEach(i => {
            const date = `${i.year}.${i.month}`;
            params[date] = i.fte ? i.fte.toFixed(2) : 0;
        });

        return [params];
    }

    return (
        <TableC
            columns={getColumns()}
            data={getDataSource()}
            className="fte"
        />
    );
}

export default Fte;


// WEBPACK FOOTER //
// ./src/components/user/require/tables/Fte.js